const KEY = 'OPEN_TALK';

export { KEY };
